<template>
	<div class="skyCheckbox">
		<el-checkbox-group v-model="checkbox" @change="handleChange" v-bind="$attrs">
			<el-checkbox
				class="margin_right_10"
				v-for="(item, index) in list"
				:label="item[props.value]"
				:disabled="filterOptions ? item.disabled() : item[props.disabled] == 1"
				:key="index"
				:border="border"
			>
				{{ item[props.label] }}
			</el-checkbox>
		</el-checkbox-group>
	</div>
</template>
<script>
import googleads from '@/backend/services/googleAds/googleAds.js';
export default {
	name: 'skyCheckbox',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		border: {
			type: Boolean,
			default: true,
		},
		options: {
			type: Array,
			default() {
				return [];
			},
		},
		props: {
			type: Object,
			default() {
				return {
					label: 'name',
					value: 'code',
				};
			},
		},
		dict: {
			type: String,
			default: '',
		},
		code: {
			type: String,
			default: '',
		},
		getOptions: {
			type: Function,
			default: null,
		},
		filterOptions: {
			type: Function,
			default: null,
		},
	},
	watch: {
		getOptions: {
			handler: function (val) {
				if (val) {
					this.list = val();
				}
			},
			immediate: true,
		},
		dict: {
			handler: function (val) {
				if (val) {
					this.getDict(val);
				}
			},
			immediate: true,
		},
		code: {
			handler: function (val) {
				if (val) {
					this.getCode(val);
				}
			},
			immediate: true,
		},
		options: {
			handler(val) {
				if (val) {
					// this.list = val;
					this.list = this.filterOptions ? this.filterOptions(val) : val;
				}
			},
			immediate: true,
		},
		value: {
			handler(val) {
				if (val) {
					this.checkbox = val;
				}
			},
			immediate: true,
		},
	},
	data() {
		return {
			checkbox: [],
			list: [],
		};
	},
	methods: {
		handleChange(val) {
			this.$emit('input', val);
			this.$emit('change', val);
		},
		async getCode(code) {
			let res = await googleads.codeFun(code);
			this.list = this.filterOptions ? this.filterOptions(res.data) : res.data;
		},
		async getDict(dict) {
			let res = await googleads.dictFun(dict);
			this.list = this.filterOptions ? this.filterOptions(res.data) : res.data;
		},
	},
};
</script>
